<script lang="ts">
    import { base64ToBlob } from "@/utils/image";
    import { Camera, CameraResultType, CameraSource } from "@capacitor/camera";
    import { Capacitor } from "@capacitor/core";

    let {
        isUploading,
        imageProfile,
        type = "Attach image",
        onUpdateImage,
        source = CameraSource.Prompt,
    } = $props();

    // Detectamos si estamos en entorno web NO nativo
    const isNative = Capacitor.isNativePlatform();

    async function openCamera() {
        // ✅ Si estamos en web, usamos input file
        if (!isNative) {
            document.getElementById("fileInput").click();
            return;
        }

        try {
            const photo = await Camera.getPhoto({
                quality: 90,
                allowEditing: false,
                resultType: CameraResultType.Base64,
                source,
            });

            if (photo?.base64String) {
                const blob = base64ToBlob(
                    photo.base64String,
                    `image/${photo.format}`,
                );
                onUpdateImage?.(blob);
            }
        } catch (err) {
            console.error("❌ Error con cámara:", err);
        }
    }

    async function onFileSelected(event: any) {
        const file = event.target.files?.[0];
        if (!file) return;
        onUpdateImage?.(file);
    }

    function removeImage() {
        onUpdateImage?.("remove");
    }
</script>

<div class="file">
    {#if isUploading}
        <div class="file__image --attached">
            <i class="fal fa-clock"></i>
            <p>Uploading...</p>
        </div>
    {:else if imageProfile}
        <span
            class="file__preview"
            style="background-image: url('{imageProfile}')"
        ></span>
        <i class="file__delete fal fa-trash-alt" on:click={removeImage}></i>
    {:else}
        <button type="button" class="file__image" on:click={openCamera}>
            <i class="fas fa-image"></i>
            <p>{type}</p>
        </button>

        <!-- ✅ Input para web -->
        <input
            id="fileInput"
            type="file"
            accept="image/*"
            on:change={onFileSelected}
            style="display:none"
        />
    {/if}
</div>

<style lang="scss">
    @use "./styles/index.scss";
</style>
